module.exports = __webpack_public_path__ + "img/chest-open.42e7ba5a.png";